import { MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";

import { useMachinesAsOf } from "@/hooks/useComplexes";
import { getMachineHealth } from "@/utils/machineHealth";
import { committedModeFor, labelForLedMode } from "@/utils/machineLedMode";

import { HealthyIndicator } from "./HealthyIndicator";

type FieldDevicesProps = {
  machineField: MachinePublicHydrated;
};

function FieldDevices({ machineField }: FieldDevicesProps) {
  const asOfMs = useMachinesAsOf();
  const health = getMachineHealth(machineField, asOfMs);
  const mode = committedModeFor(machineField);

  return (
    <div className="flex items-center gap-2">
      <div className="text-xs text-gray-400">{labelForLedMode(mode)}</div>
      <HealthyIndicator health={health} />
    </div>
  );
}

export { FieldDevices };
